<template>
  <div class="container text-center">
    <div class="row print" v-if="$session.get('CustCode') != 574">
      <div class="Border m-1 py-2 w-100">
        <div class="row mt-3">
          <div class="col-md-9 col-12">
            <div class="row">
              <div class="col-5">
                <div class="row">
                  <div class="col-md-6 col-12 text-left mt-2"><span class="">شماره سهام دار</span></div>
                  <div class="col-md-6 col-12 text-right pr-0">
                    <div class="mt-2">{{ $session.get('UserInfoNetPa').shomareOzv }}</div>
                  </div>
                </div>
              </div>
              <div class="col-7 text-center">
                <div class="font-weight-bold" style="font-size: 15px">گواهینامه سهام</div>
                <div class="font-weight-bold mt-1" style="font-size: 15px">شرکت تعاونی اعتبار کارکنان سازمان تامین اجتماعی</div>
                <div class="font-weight-bold mt-1" style="font-size: 15px">( سهامی خاص )</div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12 mt-2">
                <div class="text-right mr-5">
                  <span class="font-16px"> مبلغ اسمی هر سهم : </span>
                  <span class="font-weight-bold font-16px"> {{ $Comma3ragham(Data.arzeshHarSahm) }} </span>
                  <span class="font-16px"> ریال </span>
                </div>
                <div class="text-right mt-3 mr-5">
                  <span class="font-16px"> نام دارنده سهــم :</span><span class="font-weight-bold font-16px"> {{ $session.get('UserInfoNetPa').ozvName }} {{ $session.get('UserInfoNetPa').ozvFamily }} </span>
                </div>
              </div>
            </div>
            <div class="row text-right pr-5">
              <div class="col-12 mt-3">
                <span class="font-16px"> شماره شناسنامه:</span><span class="font-weight-bold font-16px"> 1272241327 </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="font-16px"> محل تولد :</span
                ><span class="font-weight-bold font-16px" dir="rtl"> اصفهان </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="font-16px"> نام پدر :</span
                ><span class="font-weight-bold font-16px"> {{ $session.get('UserInfoNetPa').pedar ? $session.get('UserInfoNetPa').pedar : '______' }} </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                <span class="font-16px"> کد ملی :</span
                ><span class="font-weight-bold font-16px" dir="rtl"> 1238856857 </span>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-12 text-center pr-0">
            <img style="height: 15vh" :src="'data:image/png;base64,' + Image.logo.binary" />
            <div class="text-center">
              <div class="mt-2">شماره ثبت : 371507</div>
              <div class="">شناسه ملی : 10320209835</div>
              <div class="">تاریخ ثبت شرکت: 1389/01/17</div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 text-right text-center font-weight-bold" style="font-size: 15px !important">
            <span>این ورقه نماینده یک سهم .</span>
            <span>ده میلیون ریال</span>
            <span>ی</span>
            <span> می باشد </span>
          </div>
          <div class="col-12 text-right text-center" style="font-size: 12px !important">(دارنده سهم تابع قانون تجارت و کلیه مقررات اساسنامه شرکت است)</div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12 col-12 text-center"></div>
        </div>

        <div class="row mt-4">
          <!-- <div class="col-md-2 col-12 text-center"></div> -->
          <div class="col-md-12 col-12 text-center">
            <div class="row">
              <div class="col-md-3 col-12 text-left">
                <div class="font-16px">رئیس هیئت مدیره</div>
                <div class="font-16px">{{ Data.pishNevis1 }}</div>
              </div>
              <div class="col-md-3 col-12 text-right pr-0 pt-0">
                <img style="height: 10vh" :src="'data:image/png;base64,' + Image.emza1.binary" />
              </div>
              <div class="col-md-3 col-12 text-left">
                <div class="font-16px">مدیر عامل</div>
                <div class="font-16px">{{ Data.pishNevis2 }}</div>
              </div>
              <div class="col-md-3 col-12 text-right pr-0 pt-0">
                <img style="height: 10vh" :src="'data:image/png;base64,' + Image.emza2.binary" />
              </div>
            </div>
          </div>
          <!-- <div class="col-md-2 col-12 text-center"></div> -->
        </div>
      </div>
    </div>
    <div class="row Border-Rouded" v-else>
      <div class="Border-Rouded m-1 py-2 w-100">
        <div class="row">
          <div class="col-md-4 col-12"></div>
          <div class="col-md-4 col-12">تعاونوا علی البر والتقوی</div>
          <div class="col-md-4 col-12">
            <span>شماره سریال : </span><span>{{ Data.serialNumber }}</span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-8 col-12 font-weight-bold text-right pr-5" style="font-size: 15px !important">{{ $session.get('UserInfoNetPa').customerName }}</div>
          <div class="col-md-4 col-12">تاریخ صدور : {{ $GetJalaliDate() }}</div>
        </div>
        <div class="text-center mt-2">برگه سهام</div>
        <div class="row">
          <div class="col-md-3 col-12">
            <span class="font-16px">شماره ثبت : </span><span class="font-16px">{{ Data.shomareSabt }}</span>
          </div>
          <div class="col-md-3 col-12">
            <span class="font-16px">شناسه ملی :</span><span class="font-16px">{{ Data.shenaseMeli }}</span>
          </div>
          <div class="col-md-3 col-12">
            <span class="mr-5 font-16px"> تعداد سهام</span>
            <span class="font-weight-bold"> {{ Math.floor(Taahoadat.mande.replace(/,/g, '').replace(/\./g, '') / Data.arzeshHarSahm) }} </span>
            <span class="font-16px"> سهــــم </span>
          </div>
          <div class="col-md-3 col-12">
            <span class="font-16px">مبلغ اسمی هر سهم :</span><span class="font-16px">{{ $Comma3ragham(Data.arzeshHarSahm) }}</span> ریال
          </div>
        </div>
        <div class="text-center mt-2">مشخصات صاحب برگه سهام</div>
        <div class="row mt-3">
          <div class="col-md-6 mt-2 col-12 text-center">
            <span class="font-16px"> نام خانوادگی و نام :</span><span class="font-weight-bold font-16px">{{ $session.get('UserInfoNetPa').ozvFamily }} {{ $session.get('UserInfoNetPa').ozvName }} </span>
          </div>
          <div class="col-md-6 mt-2 col-12 text-center">
            <span class="font-16px"> نام پدر :</span><span class="font-weight-bold font-16px"> {{ $session.get('UserInfoNetPa').pedar ? $session.get('UserInfoNetPa').pedar : '______' }} </span>
          </div>
          <div class="col-md-6 mt-2 col-12 text-center">
            <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px"> {{ $session.get('UserInfoNetPa').codeMeli ? $session.get('UserInfoNetPa').codeMeli : '______' }} </span>
          </div>
          <div class="col-md-6 mt-2 col-12 text-center">
            <span class="font-16px"> شماره عضویت سهامدار:</span><span class="font-weight-bold font-16px" dir="rtl"> {{ $session.get('UserInfoNetPa').shomareOzv }} </span>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-2 col-12 text-left">
            <div class="font-16px">رئیس هیئت مدیره</div>
            <div class="font-16px">{{ Data.pishNevis1 }}</div>
          </div>
          <div class="col-md-2 col-12 text-right pr-0 pt-0">
            <img style="height: 10vh" :src="'data:image/png;base64,' + Image.emza1.binary" />
          </div>
          <div class="col-md-2 col-12 text-left">
            <div class="font-16px">مدیر عامل</div>
            <div class="font-16px">{{ Data.pishNevis2 }}</div>
          </div>
          <div class="col-md-2 col-12 text-right pr-0 pt-0">
            <img style="height: 10vh" :src="'data:image/png;base64,' + Image.emza2.binary" />
          </div>
          <div class="col-md-2 col-12 text-left"><div class="font-16px">مهر شرکت</div></div>
          <div class="col-md-2 col-12 text-right pr-0 pt-0">
            <img style="height: 10vh" :src="'data:image/png;base64,' + Image.logo.binary" />
          </div>
        </div>
        <div class="px-5 mt-4" style="font-size: 11px !important">نقل و انتقال سهام صرفا در محل شرکت تعاونی واقع در آدرس تبریز، کوچه شفائیه ف بلوار شهدا ، کد پستی 5134916579</div>
        <div class="px-5 mt-1" style="font-size: 11px !important">تلفن 35291357 و فاکس 35259200 امکان پذیز می باشد</div>
        <div class="px-5 mt-1" style="font-size: 11px !important">برگه های سهام صادر شده قبلی فاقد اعتبار می باشد .</div>
        <div class="mt-3 text-left ml-3" style="font-size: 11px !important">برگه مخصوص سهامدار</div>
      </div>
    </div>
    <span class="Pointer btn btn-dark custom-class NetPa-btn mt-4 w-50 no-wrap no-print" @click="Print()">چاپ برگه سهام</span>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: ['Data', 'Taahoadat', 'Image'],
  mounted() {
    // console.log('😎 ~ mounted ~ this.Taahoadat:', this.Data)
  },

  methods: {
    Print() {
      var css = '@page { size: landscape; }',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style')

      style.type = 'text/css'
      style.media = 'print'

      if (style.styleSheet) {
        style.styleSheet.cssText = css
      } else {
        style.appendChild(document.createTextNode(css))
      }

      head.appendChild(style)

      window.print()
    },
  },
}
</script>
<style scoped>
.Border {
  border: 15px groove gray;
}
.Border-Rouded {
  border: 3px solid gray;
  border-radius: 8px;
}
.font-16px {
  font-size: 15px !important;
}
@media print {
  .no-print {
    display: none !important;
  }
  .print {
    display: inline-block !important;
  }
}
</style>
